import { IconAlertCircle } from '@developerz/ui';
import { type JSX, Show } from 'solid-js';
import { t } from '../i18n';
import type { OperatorRefusal } from '../lib/operator-credential';
import { signInAgain } from '../lib/sign-out';
import { Button } from './ui/Button';

// The operator-credential door's refusal, said on every staff write surface
// (#5724). Presenter. Two refusals, two remedies, never one sentence:
//   - `not_staff`: nothing this person can do from here, so a plain statement.
//   - `reauth_required`: staff, but signed in over an hour ago — the remedy is a
//     fresh sign-in, so it offers one: `signInAgain` signs out and reloads this
//     page onto the sign-in screen, which offers EVERY leg (staff sign in through
//     SSO as well as GitHub) and returns here.
// The `alert` shape is `<OrgUnfundedAlert/>`'s.

export function OperatorRefusalAlert(props: {
  readonly refusal: OperatorRefusal | null;
}): JSX.Element {
  return (
    <Show when={props.refusal}>
      {(refusal) => (
        <div class="alert alert--icon alert--destructive" role="alert">
          <IconAlertCircle />
          <p class="alert__title">
            {refusal() === 'not_staff' ? t('admin.operator_not_staff') : t('admin.operator_reauth')}
          </p>
          <Show when={refusal() === 'reauth_required'}>
            <p class="alert__desc">
              <Button size="sm" variant="outline" onClick={() => void signInAgain()}>
                {t('admin.operator_sign_in')}
              </Button>
            </p>
          </Show>
        </div>
      )}
    </Show>
  );
}
